import { apiClient } from '@/services/ApiClient.js'

export default {
  getDocument(orderId, documentId) {
    return apiClient
      .get(`orders/${orderId}/documents/${documentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewDocument(documentId) {
    return apiClient
      .get(`orders/view-document/${documentId}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        const blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  previousDocuments(orderId, documentId) {
    return apiClient
      .get(`orders/${orderId}/documents/${documentId}/previous`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateDocumentStatus(orderId, documentId, payload) {
    return apiClient
      .patch(`orders/${orderId}/documents/${documentId}/status`, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
